import { Badge, Tabs } from "antd";
import styled from "styled-components";

export const StyledTabs = styled(Tabs)`
  && .ant-tabs-tab {
    padding: 0px 45px 4px 20px;
  }

  .ant-tabs-nav .ant-tabs-ink-bar {
    height: 3px;
    background: #007bfb;
    border-radius: 16px 16px 0px 0px;
  }
`;

export const StyledProjectWrapper = styled.div`
  width: 100%;
  height: 100vh;
  background: #ffffff;
  padding: 24px;
`;

export const StyledProjectTitle = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 28px;

  & .ant-typography {
    margin: 0;
  }
`;

export const StyledBadge = styled(Badge)`
  && .ant-badge-dot {
  
    color: #f04b69;
  }
`;
